import { Box, Typography, Alert } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React from "react";

import { patientGoalsOfTreatmentApi } from "../../../apis";
import { PATIENT_SECTIONS } from "./detail/PatientDetail";
import IntakeField from "./IntakeField";
import IntakeHeader from "./IntakeHeader";
import LayoutWrapper from "./LayoutWrapper";

interface GoalsOfTreatmentProps {
  patientId: string;
}

const GoalsOfTreatment: React.FC<GoalsOfTreatmentProps> = ({ patientId }) => {
  const {
    data: goalsData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["goalsOfTreatment", patientId],
    queryFn: async () => {
      if (!patientId) return null;
      return patientGoalsOfTreatmentApi.getGoalsOfTreatmentByPatientId({
        patientId,
      });
    },
    enabled: !!patientId,
    retry: false,
  });

  if (isLoading) {
    return (
      <Box>
        <IntakeHeader title={PATIENT_SECTIONS.goalsOfTreatment.label} />
        <Typography>Loading goals...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box>
        <IntakeHeader title={PATIENT_SECTIONS.goalsOfTreatment.label} />
        <Alert severity="error">
          Failed to load treatment goals. Please try again.
        </Alert>
      </Box>
    );
  }

  const hasGoals = goalsData?.healthGoals && goalsData.healthGoals.length > 0;

  return (
    <>
      <IntakeHeader title={PATIENT_SECTIONS.goalsOfTreatment.label} />

      <LayoutWrapper itemsPerRow={1} spacing={3}>
        {hasGoals ? (
          goalsData?.healthGoals.map((goal, index) => (
            <IntakeField
              key={goal.id}
              label={`Goal #${index + 1}`}
              value={goal.text}
              rows={4}
              disabled={true}
            />
          ))
        ) : (
          <>
            {Array.from({ length: 3 }, (_, index) => index + 1).map((index) => (
              <IntakeField
                key={index}
                label={`Goal #${index}`}
                value="Example"
                rows={4}
                disabled={true}
              />
            ))}
          </>
        )}
      </LayoutWrapper>
    </>
  );
};

export default GoalsOfTreatment;
